import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Badge, Button, Comment, ConfigProvider, Empty, List, Space, Tag, Typography } from 'antd'
import { EyeOutlined, PlusOutlined } from '@ant-design/icons'
import { moment } from '@BUP/configs/i18n'
import { ComplaintEntryFormModal } from './form-modal.jsx'
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js'
import styles from './descriptions.module.scss'

export function ComplaintEntriesList ({ complaintEntries, complaintId, complaintMutate, ...props }) {
  const i18n = useTranslation()
  const [isNewEntryModalOpen, setIsNewEntryModalOpen] = useState(false)

  const showNewEntryModal = () => setIsNewEntryModalOpen(true)

  const handleOk = () => {
    complaintMutate()
    setIsNewEntryModalOpen(false)
  }
  const handleCancel = () => setIsNewEntryModalOpen(false)

  const customizeRenderEmpty = () => (
    <Empty description={i18n.t('common.resources.complaint-entry.label', { count: 0 })}>
      <Button type='primary' icon={<PlusOutlined />} onClick={showNewEntryModal}>
        {i18n.t('common.resources.complaint-entry.actions.create.submit', { context: 'first' })}
      </Button>
    </Empty>
  )

  return (
    <>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <List
          bordered
          itemLayout='vertical'
          dataSource={complaintEntries.sort((a, b) => moment(b.createdAt).diff(a.createdAt))}
          renderItem={entry => (
            <Badge.Ribbon
              text={i18n.t(`common.resources.complaint-entry.values.type.${entry.type}.label`)}
              color='#17bebb'
            >
              <List.Item
                key={entry.id}
                actions={[
                  <Link key={entry.id} to={`/logbook/complaints/${complaintId}/entries/${entry.id}`}>
                    <Space>
                      <EyeOutlined /><span>{i18n.t('common.resources.complaint-entry.actions.show.label')}</span>
                    </Space>
                  </Link>
                ]}
              >
                <Comment
                  author={entry.creator.user.name}
                  content={(
                    <>
                      <Typography.Title level={5}>{entry.title}</Typography.Title>
                      <Typography.Paragraph ellipsis className={styles.description_text}>{entry.content}</Typography.Paragraph>
                      {entry.complaintEntryAttachments.length > 0 && <Tag color='gold' key='entries'>{i18n.t('common.resources.complaint-entry-attachments.label', { context: 'with-count', count: entry.complaintEntryAttachments.length })}</Tag>}
                    </>
                  )}
                  datetime={moment(entry.createdAt).fromNow()}
                />
              </List.Item>
            </Badge.Ribbon>
          )}
          header={
            complaintEntries.length > 0 && (
              <Button type='primary' icon={<PlusOutlined />} onClick={showNewEntryModal}>
                {i18n.t('common.resources.complaint-entry.actions.new.submit')}
              </Button>
            )
          }
          {...props}
        />
      </ConfigProvider>
      <ComplaintEntryFormModal
        complaintId={complaintId}
        open={isNewEntryModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={i18n.t('common.resources.generic.actions.create.submit')}
        cancelText={i18n.t('common.resources.generic.actions.any.back')}
      />
    </>
  )
}
